<template>
  <div
    ref="shareWrapper"
    class="SocialShare"
    :class="{
      'is-right': isRight,
      'is-stuck': isStuck,
      'is-sticky': sticky,
      'is-bottom': isBottom,
    }"
    v-bind:style="parentStyles"
  >
    <ul ref="shareList" v-bind:style="overridingStyles">
      <slot name="first"></slot>
        <li v-for="(network, index) in networks" :class="index">
          <a
            :href="network.url"
            v-on:click="handleClick($event, index)"
            :target="getTarget(index)"
          >
          <i :class="network.awesome" />
            <span v-if="use_labels">
              {{ network.label }}
            </span>
          </a>
        </li>
      <slot name="last"></slot>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'social-share',

  props: {
    facebook: {
      default: false,
      type: Boolean,
    },

    linkedin: {
      default: false,
      type: Boolean,
    },

    twitter: {
      default: false,
      type: Boolean,
    },

    pocket: {
      default: false,
      type: Boolean,
    },

    pinterest: {
        default: false,
      type: Boolean,
    },

    mailto: {
        default: false,
      type: Boolean,
    },

    link: {
        default: false,
      type: Boolean,
    },

    small_open: {
      default: false,
      type: Boolean,
    },

    sticky: {
      default: true,
      type: Boolean,
    },

    scroll_stick: {
      default: 0,
      type: Number,
    },

    is_right: {
      default: false,
      type: Boolean,
    },

    start_higher: {
      default: 0,
      type: Number,
    },

    blocker_top: {
      default: '',
      type: String,
    },

		mailto_subject: {
    	default: 'Check this out!',
			type: String,
		},

		use_labels: {
    	default: false,
			type: Boolean,
		}
  },

  data() {
    return {
			useUtmCodes: true,
      shareURL: '',
      shareTitle: '',
      networks: {},
      isSticky: false,
      isStuck: false,
      isBottom: false,
      isRight: false,
      isMobile: false,
      reduceTop: 0,
      stickAt: 0,
      overridingStyles: {},
      parentStyles: {},
      sharer: null,
      parent: null,
      sharerStartingPoint: 0,
      sharerStopsAt: 0,
			lastScrollDepth: 0,
    }
  },

  methods: {
  	getTarget(network) {
  		switch (network) {
  			case 'email':
				case 'link':
					return '_self';
					break
				default:
					return '_blank';
			}
		},

    stickTop() {
      this.isStuck = true
      this.isBottom = false
      this.overridingStyles.top = this.stickAt + this.reduceTop + 'px'
      this.overridingStyles.marginTop = null
    },

    stickBottom(margin) {
      this.isStuck = false
      this.isBottom = true
      this.overridingStyles.top = null
      this.overridingStyles.marginTop = '-' + margin + 'px'
    },

    release() {
      this.isStuck = false
      this.isBottom = false
      this.overridingStyles.top = null
      this.overridingStyles.marginTop = null
    },

    handleScroll() {
    	if (this.isMobile || !this.isSticky) {
        if (this.isStuck || this.isBottom) {
          this.release()
        }

        return false
      }

      let scrollDepth = window.pageYOffset
			let scrollingUp = scrollDepth < this.lastScrollDepth
			this.lastScrollDepth = scrollDepth

			let parentHeight = this.parent.offsetHeight
      let parentDistanceToWindowTop = this.parent.getBoundingClientRect().top
      let sharerHeight = this.sharer.offsetHeight
      let sharerDistanceToWindowTop = this.sharer.getBoundingClientRect().top
			let releasePoint = this.sharerStartingPoint - this.sharerStopsAt
			let parentScrollLimit = -Math.abs(parentHeight - sharerHeight - this.reduceTop - this.stickAt)

			if (scrollDepth <= releasePoint) {
        if (this.isStuck || this.isBottom) {
          this.release()
        }
      } else if (parentDistanceToWindowTop <= parentScrollLimit) {
        if (!this.isBottom) {
          this.stickBottom(sharerHeight)
        }
      } else if (
				(scrollingUp && parentDistanceToWindowTop >= parentScrollLimit) ||
				(!scrollingUp && sharerDistanceToWindowTop <= this.sharerStopsAt)
			) {
        if (!this.isStuck) {
          this.stickTop()
        }
      }
    },

    handleClick(event, network) {
    	if (network === 'email') {
    		// console.log('send an email')
			}
    	else if (network === 'link') {
    		// console.log('copy the link')
			}
      else if (this.small_open) {
        let result = window.open(
          this.networks[network].url,
          network,
          this.centerWindow()
        )

        if (result) {
          event.preventDefault()
        }
      }
    },

    centerWindow(openWidth, openHeight) {
      openWidth = openWidth ? openWidth : window.innerWidth / 2
      openHeight = openHeight ? openHeight : window.innerHeight / 2

      let dualScreenLeft =
        window.screenLeft !== undefined
          ? window.screenLeft
          : window.screenX
      let dualScreenTop =
        window.screenTop !== undefined
          ? window.screenTop
          : window.screenY
      let width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : screen.width
      let height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : screen.height
      let left = width / 2 - openWidth / 2 + dualScreenLeft
      let top = height / 2 - openHeight / 2 + dualScreenTop

      return (
        'scrollbars=yes,location=yes,status=yes, width=' +
        openWidth +
        ', height=' +
        openHeight +
        ', top=' +
        top +
        ', left=' +
        left
      )
    },

    checkForMobile() {
      this.isMobile = false

      if (
        'mobile' ===
        getComputedStyle(this.sharer, ':before')
          .getPropertyValue('content')
          .replace(/"/g, '')
      ) {
        this.isMobile = true
      }
    },

    setupValues() {
      if (this.blocker_top) {
        const blocker = document.getElementById(this.blocker_top)

        if (blocker) {
          this.reduceTop = document.getElementById(
            this.blocker_top
          ).offsetHeight
        }
      }

      if (this.scroll_stick >= 0) {
        this.stickAt = this.scroll_stick
      } else {
        this.isSticky = false
      }

      this.sharerStartingPoint = this.sharer.getBoundingClientRect().top
      this.sharerStopsAt = this.stickAt + this.reduceTop
    },

    handleResize() {
      this.checkForMobile()
      this.setupValues()
    },

    getShareableUrl(network) {
      let shareableUrl = window.location.href

      if (this.useUtmCodes) {
        shareableUrl += (window.location.search) ? '&' : '?'
        shareableUrl += `utm_source=social&utm_medium=${network}&utm_campaign=fb-social-share`
      }

      return encodeURIComponent(shareableUrl)
    },

		getShareableMailto() {
    	let subject = encodeURIComponent(this.mailto_subject)
			let body = encodeURIComponent(document.title + ' ' + window.location.href)

			return `mailto:?Subject=${subject}&Body=${body}`
		},
  },

  created() {
    if (this.sticky) {
			this.isSticky = true
      window.addEventListener('scroll', this.handleScroll)
      window.addEventListener('resize', this.handleResize)
    }

    this.shareTitle = encodeURIComponent(document.title)

    if (this.twitter) {
      this.networks.twitter = {
        url: 'https://twitter.com/intent/tweet?text=' +
            this.getShareableUrl('twitter'),
        awesome: ['fab', 'fa-x-twitter'],
        label: 'Tweet'
      }
    }

    if (this.linkedin) {
      this.networks.linkedin = {
        url:
            'https://www.linkedin.com/shareArticle?mini=true&title=' +
            this.shareTitle +
            '&url=' +
            this.getShareableUrl('linkedin'),
        awesome: ['fab', 'fa-linkedin-in'],
        label: 'Share',
      }
    }

    if (this.facebook) {
      this.networks.facebook = {
        url:
          'https://www.facebook.com/sharer/sharer.php?u=' +
          this.getShareableUrl('facebook'),
        awesome: ['fab', 'fa-facebook-f'],
				label: 'Share',
      }
    }

		if (this.pinterest) {
			this.networks.pinterest = {
				url:
					'https://www.pinterest.com/pin/create/link/?media=&url=' +
					this.getShareableUrl('pinterest') +
					'&description=' +
					this.shareTitle,
				awesome: ['fab', 'fa-pinterest'],
				label: 'Pin'
			}
		}

    if (this.pocket) {
      this.networks.pocket = {
        url: 'https://getpocket.com/edit?url=' + this.getShareableUrl('pocket'),
        awesome: ['fab', 'fa-get-pocket'],
				label: 'Save',
      }
    }

		if (this.link) {
			this.networks.link = {
				url: window.location.href,
				awesome: ['fas', 'fa-link'],
				label: 'link',
			}
		}

    if (this.mailto) {
			this.networks.email = {
				url: this.getShareableMailto(),
				awesome: ['far', 'fa-envelope'],
				label: 'Email',
			}
		}
  },

  destroyed() {
    if (this.sticky) {
      window.removeEventListener('scroll', this.handleScroll)
      window.removeEventListener('resize', this.handleResize)
    }
  },

  mounted() {
    this.parent = this.$el.parentElement
    this.sharer = this.$refs.shareList

    if (this.is_right) {
      this.isRight = true
    }

    if (this.sticky) {
      this.checkForMobile()
      this.setupValues()
    }
  },
}
</script>
